import React from 'react';

interface SettingHeaderSeperatorProps {
  sectionName?: string;
}

const SettingHeaderSeperator = ({ sectionName }: SettingHeaderSeperatorProps) => (
  <>
    <div className="my-48 border-0 border-b border-solid border-grayscale-beige" />
    <div className="mb-24 font-suisse-intl-mono text-caption-md text-primary-magenta">
      {sectionName}
    </div>
  </>
);

export default SettingHeaderSeperator;
